import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';
import {attachmentAttributesType} from '../../constants/proptype-validation';

/**
 * This component is responsible to render issue's attachment name with tooltip (in case its name is too long)
 * The tooltip will be appended to the given container (if not specified to the default one).
 * We override the style of the tooltip target to be `display: block`,
 * because it's set to be `display: inline` by our global css which breaks the tooltip.
 * @param attachment
 * @param container
 * @returns {JSX.Element}
 */
const IssueAttachmentName = ({attachment, container = document.body}) => (
  <OverflowTooltip
    autoTipOnEllipsis
    place={Tooltip.Places.BOTTOM}
    container={container}
    style={{maxWidth: '60%'}}
    getTargetProps={() => ({style: {display: 'block'}})}
  >
    <span className="IssueAttachmentName">{attachment.name}</span>
  </OverflowTooltip>
);

IssueAttachmentName.displayName = 'IssueAttachmentName';
IssueAttachmentName.propTypes = {
  attachment: attachmentAttributesType.isRequired,
  container: PropTypes.oneOf([PropTypes.func, PropTypes.element])
};

export default IssueAttachmentName;
